import { ApparelShowcase } from '@/features/site/home/ApparelShowcase';
import { Capabilities } from '@/features/site/home/Capabilities';
import { ClosingCta } from '@/features/site/home/ClosingCta';
import { Hero } from '@/features/site/home/Hero';
import { Locations } from '@/features/site/home/Locations';
import { PrivateLabel } from '@/features/site/home/PrivateLabel';
import { SportsShowcase } from '@/features/site/home/SportsShowcase';
import { WhyUs } from '@/features/site/home/WhyUs';
import { Seo } from '@/features/site/Seo';
import { useSite } from '@/features/site/SiteProvider';
import { InquirySection } from '@/features/site/sections';
import { SITE_URL } from '@/lib/utils';

export default function HomePage() {
  const { settings } = useSite();
  const location = settings.contact.locations[0];
  return (
    <>
      <Seo
        path="/"
        image="/images/photos/pakistani-garment-workshop-1440.webp"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: settings.company.legalName,
          url: SITE_URL,
          ...(location ? { address: { '@type': 'PostalAddress', streetAddress: location.address, addressCountry: 'PK' } } : {}),
        }}
      />
      <Hero />
      <Capabilities />
      <ApparelShowcase />
      <SportsShowcase />
      <PrivateLabel />
      <WhyUs />
      <Locations />
      <ClosingCta />
      <InquirySection eyebrow="Request a quote" heading="Tell us about your production" />
    </>
  );
}
